import { CustomAffichage, ProprieteAffichee, TypePropriete } from "./proprieteAffichee";

export class SiteApiKey {
    siteApiKeyId: number;
    name: string = '';
    keyPrefix: string = '';
    siteId: number;
    createdAt: Date;
    expiresAt: Date | null = null;
    isActive: boolean;

    getProprietesAffichees() {
        let tab: ProprieteAffichee[] = [];
        tab.push(new ProprieteAffichee('name', 'MINE_TRACKER.NAME'));
        tab.push(new ProprieteAffichee('keyPrefix', 'MINE_TRACKER.KEY_PREFIX'));
        tab.push(new ProprieteAffichee('createdAt', 'MINE_TRACKER.CREATED_AT', '', new CustomAffichage(TypePropriete.Date)));
        tab.push(new ProprieteAffichee('expiresAt', 'MINE_TRACKER.EXPIRES_AT', '', new CustomAffichage(TypePropriete.Date)));
        tab.push(new ProprieteAffichee('isActive', 'MINE_TRACKER.STATUS', '', new CustomAffichage(TypePropriete.Boolean)));
        return tab;
    }
}
